import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";

function AddLoyaltyOffer() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const token = localStorage.getItem("astroVani-admin-token");

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const IMAGE_FOR_OPTIONS = [
    { label: "Home", value: "home" },
    { label: "Wallet", value: "wallet" },
    { label: "Astrologer Profile", value: "astrologer_profile" },
    { label: "Astrologers List", value: "astrologers" },
    { label: "Astrologers Category", value: "astrologers_category" },
    { label: "Free AI Chat", value: "free_ai_chat" },
    { label: "Pooja Listing", value: "pooja_listing" },
    { label: "Pooja Details", value: "pooja_details" },
    { label: "Services", value: "services" },
  ];

  /* ================= FETCH DATA (EDIT) ================= */

  useEffect(() => {
    if (!id) return;

    const fetchDetails = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/loyaltyOffer/${id}`,
          { headers: { Authorization: token } }
        );

        const data = res.data?.data || res.data;

        // format dates for datetime-local
        const formatDateTime = (dateVal, timeVal) => {
          if (dateVal && timeVal) {
            return `${dateVal.split("T")[0]}T${timeVal}`;
          }
          if (!dateVal) return "";
          return new Date(dateVal).toISOString().slice(0, 16);
        };

        reset({
          title: data.title || "",
          startDate: formatDateTime(data.startDate, data.startTime),
          endDate: formatDateTime(data.endDate, data.endTime),
          minAmount: data.minAmount || "",
          maxAmount: data.maxAmount || "",
          giftPercentage: data.giftPercentage || "",
          bonusMessage: data.bonusMessage || "",
          // displayScreens: data.displayScreens || [],
          // redirectScreenOnSuccess: data.redirectScreenOnSuccess || "",
          isActive: data.isActive !== undefined ? data.isActive : true,
        });
      } catch {
        toast.error("Failed to fetch bucket details");
      }
    };

    fetchDetails();
  }, [id, reset, token]);


  /* ================= SUBMIT ================= */

  const onSubmit = async (data) => {
    setIsLoading(true);

    const payload = {
      title: data.title,
      startDate: data.startDate.split("T")[0],
      startTime: data.startDate.split("T")[1],
      endDate: data.endDate.split("T")[0],
      endTime: data.endDate.split("T")[1],
      minAmount: Number(data.minAmount),
      maxAmount: Number(data.maxAmount),
      giftPercentage: Number(data.giftPercentage),
      bonusMessage: data.bonusMessage,
      // displayScreens: data.displayScreens || [],
      // redirectScreenOnSuccess: data.redirectScreenOnSuccess || "",
      isActive: data.isActive,
    };

    try {
      if (id) {
        await axios.patch(
          `${process.env.REACT_APP_BASEURL}/admin/loyaltyOffer/${id}`,
          payload,
          { headers: { Authorization: token } }
        );
        toast.success("Bucket updated successfully!");
      } else {
        await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/loyaltyOffer`,
          payload,
          { headers: { Authorization: token } }
        );
        toast.success("Bucket added successfully!");
      }

      navigate("/bucket-management");
    } catch (error) {
      console.error("Error saving bucket:", error);
      toast.error(id ? error?.response?.data?.message || "Failed to update bucket" : error?.response?.data?.message || "Failed to add bucket");
    } finally {
      setIsLoading(false);
    }
  };


  /* ================= UI ================= */

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold mb-0">{id ? "Edit" : "Add"} Bucket</h4>
        <button
          type="button"
          className="btn btn-primary"
          style={{ position: "relative", zIndex: 10 }}
          onClick={() => navigate("/bucket-management")}
        >
          Back
        </button>
      </div>
      <div className="card-body">
        <form className="row g-4" onSubmit={handleSubmit(onSubmit)}>
          
          <div className="col-sm-12">
            <label className="form-label">Bucket Title</label>
            <input
              className={`form-control ${errors.title ? "is-invalid" : ""}`}
              {...register("title", { required: "Title is required" })}
              placeholder="E.g. Monsoon Loyalty Recharge Offer 2026 - Bucket 5"
            />
            {errors.title && (
              <small className="text-danger">{errors.title.message}</small>
            )}
          </div>

          <div className="col-sm-6">
            <label className="form-label">Start Date & Time</label>
            <input
              type="datetime-local"
              className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
              {...register("startDate", { required: "Start date is required" })}
            />
            {errors.startDate && (
              <small className="text-danger">{errors.startDate.message}</small>
            )}
          </div>

          <div className="col-sm-6">
            <label className="form-label">End Date & Time</label>
            <input
              type="datetime-local"
              className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
              {...register("endDate", { required: "End date is required" })}
            />
            {errors.endDate && (
              <small className="text-danger">{errors.endDate.message}</small>
            )}
          </div>

          <div className="col-sm-6">
            <label className="form-label">Minimum Amount</label>
            <input
              type="number"
              className={`form-control ${errors.minAmount ? "is-invalid" : ""}`}
              {...register("minAmount", { required: "Min amount is required", min: 0 })}
            />
            {errors.minAmount && (
              <small className="text-danger">{errors.minAmount.message}</small>
            )}
          </div>

          <div className="col-sm-6">
            <label className="form-label">Maximum Amount</label>
            <input
              type="number"
              className={`form-control ${errors.maxAmount ? "is-invalid" : ""}`}
              {...register("maxAmount", { required: "Max amount is required", min: 0 })}
            />
            {errors.maxAmount && (
              <small className="text-danger">{errors.maxAmount.message}</small>
            )}
          </div>

          <div className="col-sm-6">
            <label className="form-label">Gift Percentage (%)</label>
            <input
              type="number"
              className={`form-control ${errors.giftPercentage ? "is-invalid" : ""}`}
              {...register("giftPercentage", { required: "Gift percentage is required", min: 0, max: 100 })}
            />
            {errors.giftPercentage && (
              <small className="text-danger">{errors.giftPercentage.message}</small>
            )}
          </div>



          {/* <div className="col-sm-6">
            <label className="form-label">Display Screens (Multiselect)</label>
            <Controller
              name="displayScreens"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  isMulti
                  options={IMAGE_FOR_OPTIONS}
                  placeholder="Select screens to display offer"
                  value={IMAGE_FOR_OPTIONS.filter((option) =>
                    field.value?.includes(option.value)
                  )}
                  onChange={(options) =>
                    field.onChange(options ? options.map((opt) => opt.value) : [])
                  }
                />
              )}
            />
          </div> */}

          {/* <div className="col-sm-6">
            <label className="form-label">Redirect Screen On Success</label>
            <Controller
              name="redirectScreenOnSuccess"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={IMAGE_FOR_OPTIONS}
                  placeholder="Select screen"
                  value={IMAGE_FOR_OPTIONS.find(
                    (option) => option.value === field.value
                  ) || null}
                  onChange={(option) => field.onChange(option?.value)}
                />
              )}
            />
          </div> */}

          <div className="col-sm-12">
            <label className="form-label">Bonus Message</label>
            <textarea
              rows="3"
              className={`form-control ${errors.bonusMessage ? "is-invalid" : ""}`}
              {...register("bonusMessage", { required: "Bonus message is required" })}
              placeholder="E.g. As a loyalty bonus you are getting {percentage}% Gift amount next recharge"
            ></textarea>
            {errors.bonusMessage && (
              <small className="text-danger">{errors.bonusMessage.message}</small>
            )}
            <small className="text-muted">Use <b>{`{percentage}`}</b> placeholder to inject the gift percentage in the text.</small>
          </div>

          <div className="col-sm-12">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isActiveSwitch"
                {...register("isActive")}
              />
              <label className="form-check-label" htmlFor="isActiveSwitch">
                Active
              </label>
            </div>
          </div>

          <div className="col-12">
            <button className="btn btn-primary" disabled={isLoading}>
              {isLoading ? "Saving..." : id ? "Update Bucket" : "Add Bucket"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AddLoyaltyOffer;
